import React from 'react'
import VBEvent from '../components/VBEvent'

const VBEventView = ({ match }) => {
  return <VBEvent vbEventId={match.params.id} />
}

export default VBEventView
